<div #ssChartContainer class="ss-chart-container">
    <highcharts-chart *ngIf="chartOptions && !isBusy && measurements?.length > 0"  [Highcharts]="Highcharts" [options]="chartOptions">
    </highcharts-chart>

    <div class="toro-absolute-child prevent-select" *ngIf="!isBusy && measurements?.length < 1">{{"STRINGS.NO_DATA_AVAILABLE" | translate}}</div>

    <toro-waiting-indicator *ngIf="isBusy"></toro-waiting-indicator>
</div>
